/**
 * ## Direct seating controller
 *
 * @module src/controllers/directseat
 */

"use strict";

const conf = require("../../config");
const func = require("../../controllers/func");
const chart = require("../../components/chart");
const notification = require("../../components/notification");
const l = require("../../common").localization;

let pref = null;

/** Init
 */
const init = (kd) => {
  // setup listeners attached to directseat
  kd.on("activity.update", () => {
    renderPanel(kd, pref);
  });
  kd.on("location.update", () => {
    renderPanel(kd, pref);
  });
  kd.on("directseat", (data) => {
    if (data.preference) {
      const location = kd.doc("location")[0];
      if (location.preferenceTypes[0].value === data.preference) {
        pref = null;
      } else {
        pref = data.preference;
      }
      renderPanel(kd, pref);
    } else {
      pref = null;
      renderPanel(kd, pref);
    }
  });

  renderPanel(kd, pref);
};

const getServer = (kd, locationdata, section) => {
  for (let i = 0; i < locationdata.assignments.length; ++i) {
    if (locationdata.assignments[i].section === section) {
      return locationdata.assignments[i].server;
    }
  }
  return section;
};

const getOrder = (kd, preference) => {
  const location = kd.doc("location")[0];
  const template = kd.doc("template", location.template)[0];
  const chartdata = kd.doc("chart", location.chart)[0];
  const now = Math.floor(Date.now() / 1000);

  // create object with al unique sections from template
  const seatOrder = [];
  for (let t = 0; t < template.tables.length; ++t) {
    let match = false;
    for (let i = 0; i < seatOrder.length; ++i) {
      if (seatOrder[i].section == template.tables[t].section) {
        match = true;
      }
    }
    if (!match) {
      const activity = kd.where("activity", (obj) => {
        if (obj.status == 3 && obj.section == template.tables[t].section) {
          return true;
        }
      });
      let since = 100000;
      for (let a = 0; a < activity.length; ++a) {
        if (now - activity[a].statusTimes.seated < since) {
          since = now - activity[a].statusTimes.seated;
        }
      }
      let desc = "N/A";
      if (since !== 100000) {
        desc = `${Math.floor(since / 60)}m`;
      }
      seatOrder.push({
        section: template.tables[t].section,
        server: getServer(kd, location, template.tables[t].section),
        last: since,
        description: desc,
        tables: [],
      });
    }
    for (let i = 0; i < seatOrder.length; ++i) {
      if (seatOrder[i].section == template.tables[t].section) {
        let open = true;
        let seats = 2;
        let preference1 = location.preferenceTypes[0].value;
        let preference2 = location.preferenceTypes[0].value;
        const status = kd.where("activity", (obj) => {
          const tableArray = [obj.table];
          if (obj.hasOwnProperty("join") && obj.join.length > 0) {
            for (let j = 0; j < obj.join.length; ++j) {
              tableArray.push(obj.join[j].table);
            }
          }
          if (
            obj.status == 3 &&
            tableArray.includes(template.tables[t].table)
          ) {
            return true;
          }
        });
        if (status.length > 0) {
          open = false;
        }
        for (let c = 0; c < chartdata.tables.length; ++c) {
          if (chartdata.tables[c].table === template.tables[t].table) {
            seats = chartdata.tables[c].seats;
            if (
              chartdata.tables[c].hasOwnProperty("preference1") &&
              chartdata.tables[c].preference1
            ) {
              preference1 = chartdata.tables[c].preference1;
            }
            if (
              chartdata.tables[c].hasOwnProperty("preference2") &&
              chartdata.tables[c].preference2
            ) {
              preference2 = chartdata.tables[c].preference2;
            }
            break;
          }
        }
        // check if disabled table
        if (!location.disabledTables.includes(template.tables[t].table)) {
          if (
            !preference ||
            preference1 === preference ||
            preference2 === preference
          ) {
            seatOrder[i].tables.push({
              table: template.tables[t].table,
              seats,
              open,
              preference1,
              preference2,
            });
          }
        }
      }
    }
  }

  seatOrder.sort((a, b) => {
    return parseFloat(a.section) - parseFloat(b.section);
  });

  seatOrder.sort((a, b) => {
    return parseFloat(b.last) - parseFloat(a.last);
  });
  return seatOrder;
};

const getSuggested = (seatOrder, kd) => {};

const renderPanel = (kd, preference) => {
  const seatOrder = getOrder(kd, preference);
  if (preference) {
    let title = l.translate("Suggested for preference");
    title += `<div class="directseat_bold">${preference}</div>`;
    $("#directseat_head_title_id").html(title);
  } else {
    $("#directseat_head_title_id").html(l.translate("Suggested"));
  }

  for (let i = 0; i < 3; ++i) {
    if (typeof seatOrder[i] !== "undefined") {
      $(`#directseat_head_color${i}`).css(
        "background-color",
        conf.vars.sections[seatOrder[i].section].color
      );
      if (conf.vars.sections[seatOrder[i].section].hasOwnProperty("color2")) {
        $(`#directseat_head_color${i}`).css(
          "border-left",
          `4px solid \
                    ${conf.vars.sections[seatOrder[i].section].color2}`
        );
        $(`#directseat_head_color${i}`).css(
          "border-right",
          `4px solid \
                    ${conf.vars.sections[seatOrder[i].section].color2}`
        );
      }
      $(`#directseat_head_name${i}`).html(seatOrder[i].server);
      $(`#directseat_head_last${i}`).html(seatOrder[i].description);
    } else {
      $(`#directseat_head_color${i}`).css("background-color", "transparent");
      $(`#directseat_head_name${i}`).html("");
      $(`#directseat_head_last${i}`).html("");
    }
  }

  for (let size = 2; size <= 8; size = size + 2) {
    $(`#directseat_suggested${size}`).data("table", 0);
    $(`#directseat_size${size - 1}`).data("table", 0);
    $(`#directseat_size${size}`).data("table", 0);
    $(`#directseat_suggested${size}`).html("N/A");
    $(`#directseat_suggested${size}`).css("color", "#ffffff");
    $(`#directseat_suggested${size}`).css("background-color", "#5B5B5B");
    $(`#directseat_suggested${size}`).css("border-left", "0px solid #5B5B5B");
    $(`#directseat_suggested${size}`).css("border-right", "0px solid #5B5B5B");
    let match = false;
    for (let i = 0; i < seatOrder.length; ++i) {
      for (let t = 0; t < seatOrder[i].tables.length; ++t) {
        if (
          seatOrder[i].tables[t].open &&
          (size == seatOrder[i].tables[t].seats ||
            size == seatOrder[i].tables[t].seats - 1)
        ) {
          match = true;
          $(`#directseat_suggested${size}`).data(
            "table",
            seatOrder[i].tables[t].table
          );
          $(`#directseat_size${size - 1}`).data(
            "table",
            seatOrder[i].tables[t].table
          );
          $(`#directseat_size${size}`).data(
            "table",
            seatOrder[i].tables[t].table
          );
          $(`#directseat_suggested${size}`).html(seatOrder[i].tables[t].table);
          $(`#directseat_suggested${size}`).css(
            "background-color",
            conf.vars.sections[seatOrder[i].section].color
          );
          $(`#directseat_suggested${size}`).css(
            "color",
            func.getColorByBg(conf.vars.sections[seatOrder[i].section].color)
          );
          if (
            conf.vars.sections[seatOrder[i].section].hasOwnProperty("color2")
          ) {
            $(`#directseat_suggested${size}`).css(
              "border-left",
              `4px solid \
                            ${conf.vars.sections[seatOrder[i].section].color2}`
            );
            $(`#directseat_suggested${size}`).css(
              "border-right",
              `4px solid \
                            ${conf.vars.sections[seatOrder[i].section].color2}`
            );
          }
          break;
        }
      }
      if (match) {
        break;
      }
    }
  }

  $(".directseat_suggested").off();
  $(".directseat_suggested").fastClick((e) => {
    const table = $(`#${e.target.id}`).data("table");
    chart.roomByTable(kd, table);
    $(
      `.table_lib[data-table="${table}"] > .table_base > .svg > .table > .top`
    ).trigger("mousedown");
    $(
      `.table_lib[data-table="${table}"] > .table_base > .svg > .table > .top`
    ).trigger("mouseup");
  });

  $(".directseat_size").off();
  $(".directseat_size").fastClick((e) => {
    let table = $(`#${e.target.id}`).data("table");
    if (!isNaN(table)) {
      table = parseInt(table, 10);
    }
    const size = parseInt($(`#${e.target.id}`).data("size"), 10);
    if (table !== 0) {
      const rightNow = Math.floor(Date.now() / 1000);
      const section = getSection(kd, table);
      const proposed = {
        domain: "activity",
        status: 3,
        statusTimes: {
          added: rightNow,
          seated: rightNow,
        },
        size,
        tableStatus: 2,
        notes: [],
        alerts: 0,
        waited: 0,
        quoted: 0,
        table,
        section,
        disabled: false,
        name: l.translate("Direct Seating"),
      };
      kd.update(proposed)
        .then((result) => {
          const opt = {
            position: "top",
            width: "90%",
            seconds: 2,
            h1: l.translate("Party seated"),
            body: "",
            buttons: [
              {
                description: l.translate("Ok"),
                value: "close",
              },
            ],
          };
          notification.create(opt, {}, (err2, value) => {
            notification.destroy();
          });
        })
        .catch((err3) => {
          console.log("err3", err3);
        });
    }
  });
};

const getSection = (kd, table) => {
  const location = kd.doc("location")[0];
  const templatedata = Object.assign(
    {},
    kd.doc("template", location.template)[0]
  );
  for (let i = 0; i < templatedata.tables.length; ++i) {
    if (templatedata.tables[i].table == table) {
      return templatedata.tables[i].section;
    }
  }
  return 0;
};

module.exports = {
  init,
  getOrder,
  getServer,
  renderPanel,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/directseat/index.js
 **/